import moment from 'moment';
import classNames from 'classnames';
import { throttle } from 'utils/util';
import React, { useState } from 'react';
import intl from 'react-intl-universal';
import SearchRow from 'components/ComponentOcr/SearchRow';
import AllForTab from 'components/ComponentTab/AllForTab';
import AllForGallery from 'components/ComponentGallery/AllForGallery';

import './AllForGroupGallery.scss';

const AllForGroupGallery = function (props) {
  const { cid, ids, search, tabPosition } = props;
  const cls = classNames('all-for-groupgallery');
  const [searchKey, setSearchKey] = useState('');

  const onSearch = throttle((e) => {
    setSearchKey(e || '');
  }, 160);

  const getGalleryComponent = (year, list) => {
    return {
      cid: `gallery_${year}_${cid}`,
      mode: `4`,
      info: true,
      total: false,
      search: false,
      showname: true,
      namealign: `left`,
      type: 'gallery',
      list: list.map((it) => {
        const displayName = (it && typeof it.custom === 'string' && it.custom.trim())
          ? it.custom
          : ((it && typeof it.desc === 'string' && it.desc.trim()) ? it.desc : it.name);
        return {
          link: {
            // 对外展示名称：支持换行；不填则回退到后台相册名称
            desc: displayName,
            value: it.id,
            url_labeling: it.url_labeling,
            type: 'gallery',
          },
        };
      }),
    };
  };

  const getTabList = () => {
    let timeline = {};

    (ids || []).map((it) => {
      if (it && it.id && it.name && it.start_time) {
        const displayName = (it && typeof it.custom === 'string' && it.custom.trim())
          ? it.custom
          : ((it && typeof it.desc === 'string' && it.desc.trim()) ? it.desc : it.name);
        if (searchKey && displayName.indexOf(searchKey) < 0) {
          return;
        }
        const year = moment(it.start_time).format('YYYY');
        if (!timeline[year]) {
          timeline[year] = [];
        }

        timeline[year].push(it);
      }
    });

    let keys = Object.keys(timeline);
    keys.sort((a, b) => (a > b ? -1 : 1));

    return keys.map((year) => {
      return {
        title: year,
        children: [getGalleryComponent(year, timeline[year])],
      };
    });
  };

  const tabs = getTabList();
  return (
    <div className={cls}>
      {search ? (
        <SearchRow
          placeholder={intl.get('Please input gallery name')}
          search={onSearch}
          clear={onSearch}
        />
      ) : null}
      {tabs && tabs.length > 1 ? (
        <AllForTab cid={`tab_${cid}`} list={getTabList()} mode={tabPosition} />
      ) : null}
      {tabs && tabs.length === 1 ? (
        <AllForGallery
          {...getGalleryComponent(
            tabs[0].title,
            ids.filter((it) => {
              if (searchKey) {
                const displayName = (it && typeof it.custom === 'string' && it.custom.trim())
                  ? it.custom
                  : ((it && typeof it.desc === 'string' && it.desc.trim()) ? it.desc : (it && it.name));
                if (displayName && displayName.indexOf(searchKey) < 0) {
                  return false;
                }
              }
              return true;
            })
          )}
        />
      ) : null}
    </div>
  );
};

export default AllForGroupGallery;
